import { render, staticRenderFns } from "./ButtonEmail.vue?vue&type=template&id=50cfa5da&scoped=true&"
import script from "./ButtonEmail.vue?vue&type=script&lang=js&"
export * from "./ButtonEmail.vue?vue&type=script&lang=js&"
import style0 from "./ButtonEmail.vue?vue&type=style&index=0&id=50cfa5da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50cfa5da",
  null
  
)

export default component.exports